var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnershipHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 7.79v6.57c-.49.37-1.14.47-1.72.27l-.19-.07c.59-1.16.37-2.58-.56-3.53l-3.37-3.37 2.68-.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.87 12.27 3.53 3.47v.01c-.09.32-.26.61-.5.85-.43.42-1 .63-1.56.6l-3.76-3.76c-.09.08-.13.19-.13.3 0 .13.06.27.19.35l3.57 3.5c-.1.24-.24.46-.43.65-.41.41-.95.61-1.49.61-.52 0-1.04-.19-1.44-.58l-2.2-1.99c-.48-.44-1.04-.75-1.66-.94.01-.03.01-.06.01-.09v-8.4l2.57-1.06c.74-.31 1.57-.25 2.25.12l-.16.08c-.86.43-1.47 1.25-1.64 2.23-.15.95.17 1.93.85 2.62.5.5 1.17.81 1.88.87-.05.07-.07.14-.07.21 0 .14.06.27.19.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.14 14.24c-.08.16-.18.3-.31.43-.39.39-.85.61-1.33.65l-3.61-3.6h.12c.48 0 .96-.12 1.38-.33l.32-.17 1.72-.87 1.39 1.39s0 0 .01.01c.66.67.77 1.7.31 2.49z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m3.25 16h-2.5c-.414 0-.75-.336-.75-.75v-8.5c0-.414.336-.75.75-.75h2.5c.414 0 .75.336.75.75v8.5c0 .414-.336.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.25 16h-2.5c-.414 0-.75-.336-.75-.75v-8.5c0-.414.336-.75.75-.75h2.5c.414 0 .75.336.75.75v8.5c0 .414-.336.75-.75.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.94 6.1c-.01 0-.02-.01-.04-.01l-2.29-.94c-.71-.29-1.51-.27-2.2.08l-2.73 1.37-.57.28c-.58.29-.99.85-1.1 1.49-.1.64.11 1.3.57 1.76.39.39.91.59 1.43.59.31 0 .63-.07.92-.22l.33-.17 1.43-.72 3.98-2 1.33.55v-1.41c0-.07 0-.14.02-.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnershipHandshake);
export default __webpack_public_path__ + "static/media/partnership-handshake.6d95dc9e.svg";
export { ForwardRef as ReactComponent };